import React, { useState, useEffect } from 'react';
import { useUserContext } from '../../context/user_context';
import { Link, useHistory } from 'react-router-dom';
import useMounted from '../../hooks/useMounted';
import { toast } from 'react-toastify';
import Button from '../../components/Button';
import { useUserDetailsContext } from '../../context/user_details_context';
import { Input } from '@chakra-ui/react';
import registerImage from '../../assets/registerImage.png';
function RegisterPage() {
  const history = useHistory();
  const mounted = useMounted();
  const { registerUser, signInWithGoogle, verifyUserPhone } = useUserContext();
  const [isSubmitting, setIsSubmitting] = useState(false);

  const { postUserEmailToDatabase } = useUserDetailsContext();
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [otp, setOtp] = useState('');
  const [isVerified, setIsVerified] = useState(false);
  const [phoneNumber, setPhoneNumber] = useState('');
  const [mailOtp, setMailOtp]=useState("")
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!firstName) return toast.error('Please enter name');
    if (!phoneNumber) return toast.error('Please enter phone number');

    setIsSubmitting(true);
    let name = firstName + ' ' + lastName;

    try {
      let res = await registerUser(phoneNumber, name);

      if (res.success) {
        toast.success(
          'Your account has been created'
        );
        setIsSubmitted(false);
        history.push("/login")
      } else {
        toast.error(res?.message);
      }
    } catch (error) {
      toast.error(
        `Error: ${
          error.message === 'Firebase: Error (auth/email-already-in-use).'
            ? 'Email already in use. Please verify your email and login'
            : error.message
        }`
      );
    } finally {
      if (mounted.current) setIsSubmitting(false);
    }
  };

  useEffect(() => {
    document.title = 'Mukunda jewelers | Register';
  }, []);

  const handleVerify = () => {
    if(otp==mailOtp){
    setIsSubmitted(true);
    }
    else{
      return toast.error("Invalid otp")

    }
  };

  const handleVerifyPhoneNumber = async () => {
    setIsSubmitting(true)
    let res = await verifyUserPhone(phoneNumber);
    if (res?.success) {
      setIsVerified(true)
      setMailOtp(res?.data?.otp)
      toast.success("Otp sent to Phone Number")
    }
    else{
      toast.error(res?.message)
    }
    
    setIsSubmitting(false)
  };

  return (
    <div className='flex flex-col lg:flex-row justify-center items-center min-h-screen px-4 md:px-10 py-10'>
      <div className='flex flex-col gap-4 justify-center items-center bg-[#F5F5F5] shadow-lg rounded-2xl p-6 sm:p-8 md:p-10 w-full max-w-md md:max-w-lg lg:max-w-xl'>
        <h2 className='text-black font-semibold text-2xl md:text-3xl text-center'>
          Create an Account
        </h2>
        <p className='text-[#556987] text-base md:text-lg text-center'>
          Create an account to enjoy a personalized shopping experience.
        </p>
        {isVerified && isSubmitted && (
          <div className='flex flex-col gap-4 w-full'>
            <div className='flex flex-col sm:flex-row gap-3 w-full'>
              <input
                type='text'
                style={{ height: '40px' }}
                placeholder='First name...'
                value={firstName}
                onChange={(e) => setFirstName(e.target.value)}
                className='min-w-[47%] bg-transparent outline-none border border-[#A1A1AA] rounded-lg focus:outline-none p-1 text-s'
              />
              <input
                type='text'
                style={{ height: '40px' }}
                placeholder='Last name...'
                value={lastName}
                onChange={(e) => setLastName(e.target.value)}
                className='min-w-[47%] bg-transparent outline-none border border-[#A1A1AA] rounded-lg focus:outline-none p-1 text-s'
              />
            </div>

            <input
              type='phonenumber'
              style={{ height: '40px' }}
              placeholder='Enter your Phone'
              value={phoneNumber}
              autoComplete='off'
              onChange={(e) => {}}
              className='min-w-[100%] bg-transparent outline-none border border-[#A1A1AA] rounded-lg focus:outline-none p-1 text-s'
            />
            <Button
              className='bg-[#D3A143] hover:bg-[#b98a36] text-white rounded-lg px-4 py-2 w-full text-base md:text-lg font-medium'
              type='submit'
              onClick={handleSubmit}
              disabled={isSubmitting}
            >
              Create Account
            </Button>
          </div>
        )}
        {isVerified && !isSubmitted && (
          <div className='flex flex-col gap-4'>
            <Input
              type='number'
              placeholder='Enter your otp'
              value={otp}
              onChange={(e) => setOtp(e.target.value)}
            />

            <Button
              className='bg-[#D3A143] hover:bg-[#b98a36] text-white rounded-lg px-4 py-2 w-full text-base md:text-lg font-medium'
              type='submit'
              onClick={handleVerify}
            >
              Verify otp
            </Button>
          </div>
        )}
        {!isVerified && (
          <div className='flex flex-col gap-4 w-full'>
            <input
              type='phonenumber'
              style={{ height: '40px' }}
              placeholder='Enter your phone number'
              value={phoneNumber}
              autoComplete='off'
              onChange={(e) => setPhoneNumber(e.target.value)}
              className='min-w-[100%] bg-transparent outline-none border border-[#A1A1AA] rounded-lg focus:outline-none p-1 text-s'
            />

            <Button
              className='bg-[#D3A143] hover:bg-[#b98a36] text-white rounded-lg px-4 py-2 w-full text-base md:text-lg font-medium'
              type='submit'
              disabled={isSubmitting}
              onClick={handleVerifyPhoneNumber}
            >
              Verify Phone
            </Button>
            <p onClick={handleVerifyPhoneNumber} className='text-[#008FAB]'>
              Resend otp
            </p>
          </div>
        )}
        <p className='text-[#010535] text-sm text-center'>
          Already have an account?
          <Link to='/login'>
            <span className='text-[#008FAB] hover:underline'>Sign in</span>
          </Link>
        </p>
        <div className='seperator'>
          <span>or</span>
        </div>
        <Button
          className='bg-[#010535] hover:bg-[#b98a36] text-white rounded-lg px-4 py-2 w-full text-base md:text-lg'
          type='submit'
          onClick={async () => {
            try {
              let user = await signInWithGoogle();
              await postUserEmailToDatabase(user?.email, user?.displayName);
              history.push('/');
            } catch (err) {
              toast.error(`Error: ${err.message}`);
            }
          }}
        >
          Sign in with google
        </Button>
      
      </div>

      <div className='mt-10 lg:mt-0 lg:ml-10 flex justify-center items-center w-full max-w-md'>
        <img
          src={registerImage}
          alt='Register'
          className='w-full max-w-sm sm:max-w-md md:max-w-lg h-auto rounded-lg object-contain'
        />
      </div>
    </div>
  );
}

export default RegisterPage;
